'use strict';
import * as $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse from "./app.data.-Drug-Request-Pharmacy-Response.js";
import * as $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse$0024$0024anon$002410 from "./app.data.-Drug-Request-Pharmacy-Response$$anon$10.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$() {
  this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_byName = null;
  this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_values$lzy1 = null;
  this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_valuesbitmap$1 = false;
  $n_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ as $c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ };
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype.constructor = $c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$;
/** @constructor */
function $h_Lapp_data_DrugRequestPharmacyResponse$namedEnum$() {
}
export { $h_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ as $h_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ };
$h_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype = $c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype;
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype.byName__sci_Map = (function() {
  return this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_byName;
});
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype.framework$utils$NamedEnum$_setter_$byName_$eq__sci_Map__V = (function(x$0) {
  this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_byName = x$0;
});
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype.values__sci_Vector = (function() {
  if ((!this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_valuesbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_Lapp_data_DrugRequestPharmacyResponse$().values__ALapp_data_DrugRequestPharmacyResponse());
    this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_values$lzy1 = $x_1.fromVectorUnsafe__sci_Vector__sci_Vector($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2));
    this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_valuesbitmap$1 = true;
  }
  return this.Lapp_data_DrugRequestPharmacyResponse$namedEnum$__f_values$lzy1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype.toName__Lapp_data_DrugRequestPharmacyResponse__T = (function(a) {
  var x = $s_Lapp_data_DrugRequestPharmacyResponse$__InStock__Lapp_data_DrugRequestPharmacyResponse();
  if ((x === a)) {
    return "in_stock";
  }
  var x$3 = $s_Lapp_data_DrugRequestPharmacyResponse$__CanOrder__Lapp_data_DrugRequestPharmacyResponse();
  if ((x$3 === a)) {
    return "can_order";
  }
  var x$5 = $s_Lapp_data_DrugRequestPharmacyResponse$__Unavailable__Lapp_data_DrugRequestPharmacyResponse();
  if ((x$5 === a)) {
    return "unavailable";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$.prototype.toName__O__T = (function(a) {
  return this.toName__Lapp_data_DrugRequestPharmacyResponse__T(a);
});
var $d_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$, "app.data.DrugRequestPharmacyResponse$namedEnum$", ({
  Lapp_data_DrugRequestPharmacyResponse$namedEnum$: 1,
  Lframework_utils_NamedEnum: 1
}));
export { $d_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ as $d_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ };
var $n_Lapp_data_DrugRequestPharmacyResponse$namedEnum$;
function $m_Lapp_data_DrugRequestPharmacyResponse$namedEnum$() {
  if ((!$n_Lapp_data_DrugRequestPharmacyResponse$namedEnum$)) {
    $n_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ = new $c_Lapp_data_DrugRequestPharmacyResponse$namedEnum$();
  }
  return $n_Lapp_data_DrugRequestPharmacyResponse$namedEnum$;
}
export { $m_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ as $m_Lapp_data_DrugRequestPharmacyResponse$namedEnum$ };
function $s_Lapp_data_DrugRequestPharmacyResponse$__app$data$DrugRequestPharmacyResponse$ForEachKind$$anon$11$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lapp_data_DrugRequestPharmacyResponse$__app$data$DrugRequestPharmacyResponse$ForEachKind$$anon$11$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_data_DrugRequestPharmacyResponse$__app$data$DrugRequestPharmacyResponse$ForEachKind$$anon$11$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_data_DrugRequestPharmacyResponse$__app$data$DrugRequestPharmacyResponse$ForEachKind$$anon$11$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_data_DrugRequestPharmacyResponse$__InStock__Lapp_data_DrugRequestPharmacyResponse() {
  $m_Lapp_data_DrugRequestPharmacyResponse$();
  return $t_Lapp_data_DrugRequestPharmacyResponse$__InStock;
}
export { $s_Lapp_data_DrugRequestPharmacyResponse$__InStock__Lapp_data_DrugRequestPharmacyResponse as $s_Lapp_data_DrugRequestPharmacyResponse$__InStock__Lapp_data_DrugRequestPharmacyResponse };
function $s_Lapp_data_DrugRequestPharmacyResponse$__CanOrder__Lapp_data_DrugRequestPharmacyResponse() {
  $m_Lapp_data_DrugRequestPharmacyResponse$();
  return $t_Lapp_data_DrugRequestPharmacyResponse$__CanOrder;
}
export { $s_Lapp_data_DrugRequestPharmacyResponse$__CanOrder__Lapp_data_DrugRequestPharmacyResponse as $s_Lapp_data_DrugRequestPharmacyResponse$__CanOrder__Lapp_data_DrugRequestPharmacyResponse };
function $s_Lapp_data_DrugRequestPharmacyResponse$__Unavailable__Lapp_data_DrugRequestPharmacyResponse() {
  $m_Lapp_data_DrugRequestPharmacyResponse$();
  return $t_Lapp_data_DrugRequestPharmacyResponse$__Unavailable;
}
export { $s_Lapp_data_DrugRequestPharmacyResponse$__Unavailable__Lapp_data_DrugRequestPharmacyResponse as $s_Lapp_data_DrugRequestPharmacyResponse$__Unavailable__Lapp_data_DrugRequestPharmacyResponse };
/** @constructor */
function $c_Lapp_data_DrugRequestPharmacyResponse$() {
  this.Lapp_data_DrugRequestPharmacyResponse$__f_$values = null;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_schema$lzy1 = null;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_schemabitmap$1 = false;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_circeCodec$lzy1 = null;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_circeCodecbitmap$1 = false;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_circeKeyCodec$lzy1 = null;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_circeKeyCodecbitmap$1 = false;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_derived$CanEqual$lzy1 = null;
  this.Lapp_data_DrugRequestPharmacyResponse$__f_derived$CanEqualbitmap$1 = false;
  $n_Lapp_data_DrugRequestPharmacyResponse$ = this;
  $t_Lapp_data_DrugRequestPharmacyResponse$__InStock = new $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse$0024$0024anon$002410.$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10("InStock", 0);
  $t_Lapp_data_DrugRequestPharmacyResponse$__CanOrder = new $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse$0024$0024anon$002410.$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10("CanOrder", 1);
  $t_Lapp_data_DrugRequestPharmacyResponse$__Unavailable = new $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse$0024$0024anon$002410.$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10("Unavailable", 2);
  this.Lapp_data_DrugRequestPharmacyResponse$__f_$values = new ($j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse.$d_Lapp_data_DrugRequestPharmacyResponse.getArrayOf().constr)([$s_Lapp_data_DrugRequestPharmacyResponse$__InStock__Lapp_data_DrugRequestPharmacyResponse(), $s_Lapp_data_DrugRequestPharmacyResponse$__CanOrder__Lapp_data_DrugRequestPharmacyResponse(), $s_Lapp_data_DrugRequestPharmacyResponse$__Unavailable__Lapp_data_DrugRequestPharmacyResponse()]);
}
export { $c_Lapp_data_DrugRequestPharmacyResponse$ as $c_Lapp_data_DrugRequestPharmacyResponse$ };
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.constructor = $c_Lapp_data_DrugRequestPharmacyResponse$;
/** @constructor */
function $h_Lapp_data_DrugRequestPharmacyResponse$() {
}
export { $h_Lapp_data_DrugRequestPharmacyResponse$ as $h_Lapp_data_DrugRequestPharmacyResponse$ };
$h_Lapp_data_DrugRequestPharmacyResponse$.prototype = $c_Lapp_data_DrugRequestPharmacyResponse$.prototype;
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.values__ALapp_data_DrugRequestPharmacyResponse = (function() {
  var this$1 = this.Lapp_data_DrugRequestPharmacyResponse$__f_$values;
  return this$1.clone__O();
});
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_data_DrugRequestPharmacyResponse$__f_schemabitmap$1)) {
    var this$1 = $m_Lapp_data_DrugRequestPharmacyResponse$namedEnum$();
    this.Lapp_data_DrugRequestPharmacyResponse$__f_schema$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema(this$1);
    this.Lapp_data_DrugRequestPharmacyResponse$__f_schemabitmap$1 = true;
  }
  return this.Lapp_data_DrugRequestPharmacyResponse$__f_schema$lzy1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.circeCodec__Lio_circe_Codec = (function() {
  if ((!this.Lapp_data_DrugRequestPharmacyResponse$__f_circeCodecbitmap$1)) {
    var this$1 = $m_Lapp_data_DrugRequestPharmacyResponse$namedEnum$();
    this.Lapp_data_DrugRequestPharmacyResponse$__f_circeCodec$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec(this$1);
    this.Lapp_data_DrugRequestPharmacyResponse$__f_circeCodecbitmap$1 = true;
  }
  return this.Lapp_data_DrugRequestPharmacyResponse$__f_circeCodec$lzy1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.circeKeyCodec__Lframework_utils_CirceKeyCodec = (function() {
  if ((!this.Lapp_data_DrugRequestPharmacyResponse$__f_circeKeyCodecbitmap$1)) {
    var this$1 = $m_Lapp_data_DrugRequestPharmacyResponse$namedEnum$();
    this.Lapp_data_DrugRequestPharmacyResponse$__f_circeKeyCodec$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec(this$1);
    this.Lapp_data_DrugRequestPharmacyResponse$__f_circeKeyCodecbitmap$1 = true;
  }
  return this.Lapp_data_DrugRequestPharmacyResponse$__f_circeKeyCodec$lzy1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.derived$CanEqual__s_CanEqual = (function() {
  if ((!this.Lapp_data_DrugRequestPharmacyResponse$__f_derived$CanEqualbitmap$1)) {
    this.Lapp_data_DrugRequestPharmacyResponse$__f_derived$CanEqual$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lapp_data_DrugRequestPharmacyResponse$__f_derived$CanEqualbitmap$1 = true;
  }
  return this.Lapp_data_DrugRequestPharmacyResponse$__f_derived$CanEqual$lzy1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f__$ordinal$1;
});
var $d_Lapp_data_DrugRequestPharmacyResponse$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugRequestPharmacyResponse$, "app.data.DrugRequestPharmacyResponse$", ({
  Lapp_data_DrugRequestPharmacyResponse$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_data_DrugRequestPharmacyResponse$ as $d_Lapp_data_DrugRequestPharmacyResponse$ };
var $n_Lapp_data_DrugRequestPharmacyResponse$;
function $m_Lapp_data_DrugRequestPharmacyResponse$() {
  if ((!$n_Lapp_data_DrugRequestPharmacyResponse$)) {
    $n_Lapp_data_DrugRequestPharmacyResponse$ = new $c_Lapp_data_DrugRequestPharmacyResponse$();
  }
  return $n_Lapp_data_DrugRequestPharmacyResponse$;
}
export { $m_Lapp_data_DrugRequestPharmacyResponse$ as $m_Lapp_data_DrugRequestPharmacyResponse$ };
var $t_Lapp_data_DrugRequestPharmacyResponse$__InStock = null;
function $u_Lapp_data_DrugRequestPharmacyResponse$__InStock(x) {
  $t_Lapp_data_DrugRequestPharmacyResponse$__InStock = x;
}
export { $t_Lapp_data_DrugRequestPharmacyResponse$__InStock as $t_Lapp_data_DrugRequestPharmacyResponse$__InStock, $u_Lapp_data_DrugRequestPharmacyResponse$__InStock as $u_Lapp_data_DrugRequestPharmacyResponse$__InStock };
var $t_Lapp_data_DrugRequestPharmacyResponse$__CanOrder = null;
function $u_Lapp_data_DrugRequestPharmacyResponse$__CanOrder(x) {
  $t_Lapp_data_DrugRequestPharmacyResponse$__CanOrder = x;
}
export { $t_Lapp_data_DrugRequestPharmacyResponse$__CanOrder as $t_Lapp_data_DrugRequestPharmacyResponse$__CanOrder, $u_Lapp_data_DrugRequestPharmacyResponse$__CanOrder as $u_Lapp_data_DrugRequestPharmacyResponse$__CanOrder };
var $t_Lapp_data_DrugRequestPharmacyResponse$__Unavailable = null;
function $u_Lapp_data_DrugRequestPharmacyResponse$__Unavailable(x) {
  $t_Lapp_data_DrugRequestPharmacyResponse$__Unavailable = x;
}
export { $t_Lapp_data_DrugRequestPharmacyResponse$__Unavailable as $t_Lapp_data_DrugRequestPharmacyResponse$__Unavailable, $u_Lapp_data_DrugRequestPharmacyResponse$__Unavailable as $u_Lapp_data_DrugRequestPharmacyResponse$__Unavailable };
//# sourceMappingURL=app.data.-Drug-Request-Pharmacy-Response$.js.map
